import qs from 'qs';
import request from '../../../../shared/lib/request';
import { API, RPC } from '../../../../shared/constants';

const create = (content) =>
  request({
    url: API.TUTOR_TUTEE,
    method: 'POST',
    data: content,
  });

const getAll = (collaboratoreId, escludiScaduti) =>
  request({
    url: API.TUTOR_TUTEE,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'tutor',
          value: collaboratoreId || null,
        },
        escludiScaduti && {
          type: 'custom',
          value: 'non-scaduti',
        },
      ].filter((o) => o),
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByTutee = (collaboratoreId, isTutee) =>
  request({
    url: API.TUTOR_TUTEE,
    method: 'GET',
    params: {
      associazione: isTutee ? 'tutee' : false,
      filter: [
        {
          type: 'eq',
          field: 'tutee',
          value: collaboratoreId || null,
        },
      ].filter((o) => o),
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getCurrentTutorTutee = (tutorId, tuteeId) =>
  request({
    url: API.TUTOR_TUTEE,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'tutee',
          value: tuteeId || null,
        },
        {
          type: 'eq',
          field: 'tutor',
          value: tutorId || null,
        },
        {
          type: 'custom',
          value: 'non-scaduti',
        },
      ].filter((o) => o),
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const get = (id) =>
  request({
    url: `${API.TUTOR_TUTEE}/${id}`,
    method: 'GET',
  });

const put = (content) =>
  request({
    url: `${API.TUTOR_TUTEE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const del = (id) =>
  request({
    url: `${API.TUTOR_TUTEE}/${id}`,
    method: 'DELETE',
  });

const getComediazioni = (page) =>
  request({
    url: `${API.COMEDIAZIONE}`,
    method: 'GET',
    params: {
      page,
      'order-by': [
        {
          type: 'field',
          field: 'dataRichiesta',
          direction: 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getComediazioniWithSearch = (page, filters) => {
  const filter = [];

  if (filters.codice || filters.intestatario || filters.collaboratore) {
    filter.push({
      type: 'leftjoin',
      field: 'pratica',
      alias: 'praticaAlias',
    });

    if (filters.codice) {
      filter.push({
        type: 'like',
        alias: 'praticaAlias',
        field: 'codice',
        value: `%${filters.codice}%`,
      });
    }

    if (filters.intestatario) {
      filter.push({
        type: 'leftjoin',
        parentAlias: 'praticaAlias',
        alias: 'intestatario',
        field: 'primoIntestatario',
      });
      filter.push({
        type: 'like',
        alias: 'intestatario',
        field: 'nominativo',
        value: `%${filters.intestatario}%`,
      });
    }

    if (filters.collaboratore) {
      filter.push({
        type: 'like',
        alias: 'praticaAlias',
        field: 'nominativoCollaboratore',
        value: `%${filters.collaboratore}%`,
      });
    }
  }

  if (filters.tutor) {
    filter.push({
      type: 'like',
      field: 'nominativoTutor',
      value: `%${filters.tutor}%`,
    });
  }

  if (filters.dataRichiestaDa) {
    filter.push({
      type: 'gte',
      format: 'U',
      field: 'dataRichiesta',
      value: +filters.dataRichiestaDa,
    });
  }

  if (filters.dataRichiestaA) {
    filter.push({
      type: 'lte',
      format: 'U',
      field: 'dataRichiesta',
      value: +filters.dataRichiestaA,
    });
  }

  return request({
    url: `${API.COMEDIAZIONE}`,
    method: 'GET',
    params: {
      page: page || 1,
      'order-by': [
        {
          type: 'field',
          field: 'dataRichiesta',
          direction: 'desc',
        },
      ],
      filter,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
};


const richiediComediazione = (praticaid) =>
  request({
    url: RPC.GESTIONE_RICHIESTA_COMEDIAZIONE,
    method: 'POST',
    data: {
      method: 'richiesta_comediazione',
      params: {
        praticaid,
      },
    },
  });

const gestisciComediazione = ({ praticaid, comediazioneid, motivazione }, method) =>
  request({
    url: RPC.GESTIONE_RICHIESTA_COMEDIAZIONE,
    method: 'POST',
    data: {
      method,
      params: {
        praticaid,
        comediazioneid,
        motivazione,
      },
    },
  });

const RuoloService = {
  getAll,
  get,
  put,
  del,
  create,
  richiediComediazione,
  getComediazioni,
  getComediazioniWithSearch,
  gestisciComediazione,
  getByTutee,
  getCurrentTutorTutee,
};

export default RuoloService;



// WEBPACK FOOTER //
// ./app/shared/services/api/tutor/index.js